import React, { FC } from 'react';
import { BigidBody1 } from '@bigid-ui/components';
import { Box } from '@mui/material';
import { BigidChevronDownIcon, BigidChevronUpIcon } from '@bigid-ui/icons';
import { useToggle } from '../../../../../../hooks/useToggle';
import { LanguageContainer } from '../../../../../../state/languageContainer';

export const DescriptionAccordion: FC<{ text?: string }> = ({ text }) => {
  const { BigIdMeTranslate } = LanguageContainer.useContainer();
  const [isShown, toggle] = useToggle();
  return (
    <>
      {isShown && <BigidBody1 mb={2}>{text}</BigidBody1>}
      <Box
        onClick={e => {
          e.stopPropagation();
          toggle();
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <BigidBody1 size="small">
          {isShown
            ? BigIdMeTranslate('consumer_web_general_view-less')
            : BigIdMeTranslate('consumer_web_general_view-more')}
        </BigidBody1>
        {isShown ? <BigidChevronUpIcon size="small" /> : <BigidChevronDownIcon size="small" />}
      </Box>
    </>
  );
};
